import { UseEInvoicingCreateKYCError } from '../../../hooks/useEInvoicingCreateKYC'

export const getErrorMessageKeyFromResponse = (errorBody: UseEInvoicingCreateKYCError['body']): string => {
  if (errorBody?.title === 'LegalUnitEstablishmentUsedForAnotherTarget') {
    return 'e_invoice.kyc.step.company_details.notify.error.siret'
  }

  // TODO, at the moment the backend doesn't return detail of the invalid fields
  // We need to update it but it's not straight forward.
  // For now the only rule is on SIRET format, so we can safely assume any validation failed error is due to SIRET
  if (errorBody.detail === 'Validation failed') {
    return 'e_invoice.kyc.step.company_details.notify.error.invalid_siret'
  }

  return 'e_invoice.kyc.step.company_details.notify.error.generic'
}
